import moment from 'moment';

function sortByDate(echeancier, sort, sens) {
  echeancier.sort((a, b) => {
    if (a.tiersId > b.tiersId) return -1;
    if (a.tiersId === b.tiersId) {
      if (moment(a[sort]).isAfter(moment(b[sort]))) return sens === 'DESC' ? 1 : -1;
      if (moment(a[sort]).isSame(moment(b[sort]))) return 0;
      return sens === 'DESC' ? -1 : 1;
    }
    return 1;
  });
}

function sortByMontant(echeancier, sort, sens) {
  echeancier.sort((a, b) => {
    if (a.tiersId > b.tiersId) return -1;
    if (a.tiersId === b.tiersId) {
      if (a[sort] > b[sort]) return sens === 'DESC' ? 1 : -1;
      if (a[sort] === b[sort]) return 0;
      return sens === 'DESC' ? -1 : 1;
    }
    return 1;
  });
}

export default function sortEcheance(echeancier, sort) {
  if (sort && sort.name) {
    if (sort.typeSort === 'date') sortByDate(echeancier, sort.name, sort.sens);
    if (sort.typeSort === 'montant') sortByMontant(echeancier, sort.name, sort.sens);
    return;
  }
  echeancier.sort((a, b) => {
    if (a.tiersId > b.tiersId) return -1;
    if (a.tiersId === b.tiersId) {
      if (a.dateEcheance === null && b.dateEcheance !== null) return -1;
      if (a.dateEcheance !== null && b.dateEcheance === null) return 1;
      if (moment(a.dateEcheance).isAfter(moment(b.dateEcheance))) return -1;
      if (moment(a.dateEcheance).isSame((moment(b.dateEcheance)))) {
        if (a.debutPeriode === null && b.debutPeriode !== null) return -1;
        if (a.debutPeriode !== null && b.debutPeriode === null) return 1;
        if (moment(a.debutPeriode).isAfter(moment(b.debutPeriode))) return -1;
        if (moment(a.debutPeriode).isSame(moment(b.debutPeriode))) {
          if (a.finPeriode === null && b.finPeriode !== null) return -1;
          if (a.finPeriode !== null && b.finPeriode === null) return 1;
          if (moment(a.finPeriode).isAfter(moment(b.finPeriode))) return -1;
          if (moment(a.finPeriode).isSame(moment(b.finPeriode))) return 0;
        }
      }
    }
    return 1;
  });
}
